<div class="d-flex justify-content-end">
    <button
        routerLink="/records/query/new"
        class="btn btn-info btn-request-records">
        Query Documents
        <i class="fa fa-file-text ms-1"></i>
    </button>
</div>
<kno2-table
    class="w-100"
    [columns]="columns()"
    [data]="queryHistory().items"
    [rowActions]="rowActions"
    [emptyMessage]="emptyMessage">
    <ng-template
        #queryDate
        let-query>
        <span
            class="dashboard-date"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            [title]="query.createDate | date: 'MM/dd/yyyy HH:mm:ss UTC'">
            {{ query.createDate | localDate | recentActivityEventDate }}
        </span>
    </ng-template>
    <ng-template
        #rowActions
        let-query>
        <button
            (click)="resumeQuery(query)"
            class="btn"
            alt="Load saved query"
            data-bs-toggle="tooltip"
            title="Load saved query">
            <i class="fa fa-search"></i>
        </button>
        <button
            (click)="removeHistoryEntry(query.id)"
            [disabled]="isDeleting"
            class="btn ms-1"
            alt="Remove"
            data-bs-toggle="tooltip"
            title="Remove">
            <i class="fa fa-trash"></i>
        </button>
    </ng-template>
    <ng-template #emptyMessage>
        <div class="text-center">
            No previous queries.
            <a
                class="blue-link"
                routerLink="/records/query/new">
                Query Documents
            </a>
        </div>
    </ng-template>
</kno2-table>
<div class="d-flex justify-content-end">
    <kno2-pagination
        [collectionSize]="queryHistory().totalCount"
        [page]="queryOptions().pageNumber"
        [pageSize]="queryOptions().pageSize"
        (pageChange)="queryOptionsChange({ pageNumber: $event })" />
</div>
